export {
  clientFieldsApi,
  useGetClientFieldsQuery,
  useLazyGetClientFieldsQuery,
  useGetClientFieldByIdQuery,
  useLazyGetClientFieldByIdQuery,
  useCreateClientFieldMutation,
  useEditClientFieldMutation,
  useDeleteClientFieldMutation,
} from './api';
export {
  ClientFieldsEndpoints,
  type ModelClientField,
  type CreateClientFieldRequest,
  type CreateClientFieldResponse,
  type DeleteClientFieldRequest,
  type DeleteClientFieldResponse,
  type EditClientFieldRequest,
  type EditClientFieldResponse,
  type GetClientFieldByIdRequest,
  type GetClientFieldByIdResponse,
  type GetClientFieldsRequest,
  type GetClientFieldsResponse,
} from './types';
